import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { singlePlanProducts } from '../../constants/single-plan-products';
import { Discount } from '../../model/discount';
import { Location } from '@angular/common';

import { ActivatedRoute, Router } from '@angular/router';
import { SessionStorageService } from 'src/app/shared/services/session-storage.service';
import { environment } from '../../../../environments/environment';
import { Product } from '../../model/product';

@Component({
    selector: 'pme-product-choice',
    templateUrl: './product-choice.component.html',
    styleUrls: ['./product-choice.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class ProductChoiceComponent implements OnInit {

  @Input() cardTitle: string;
  @Input() changeText: string;
  @Input() changeLink: string;
  @Input() productName: string;
  @Input() totalValue: string;
  @Input() description: string;
  @Input() extraBalanceCoupon: Discount;
  @Input() newProduct:Product;
  @Input() shopWindowLink: string;
  @Input() startSubscription:string;
  @Input() endSubscription:string;
  @Input() orderCode: number;
  @Input() productNameBold: boolean;

  private _showPlanResume: boolean = true;

  @Input()
  set showPlanResume(value: boolean | undefined) {
    this._showPlanResume = value ?? true; 
  }

  get showPlanResume(): boolean {
    return this._showPlanResume;
  }
  
  singlePlanProduct: boolean;
  classificationIdentifier : string;
  newChangeLink : string;
  validationToken: string;
  location: Location;
  constructor(
    private route: ActivatedRoute,
    private sessionStorageService: SessionStorageService,
    private router: Router,
  ) {
    this.singlePlanProduct = singlePlanProducts.includes(sessionStorage.getItem('classificationIdentifier'));
    this.classificationIdentifier = this.sessionStorageService.checkAndSetClassification(this.route);
    this.sessionStorageService.setValidationToken(this.route);
    if(sessionStorage.getItem('validationToken')){
      this.validationToken = sessionStorage.getItem('validationToken');
    }
  
  }
  navigateToUrl() {
    this.location.back();
    // if (this.redirectUrl) {
    //   window.location.href = this.redirectUrl;
    //   // this.router.navigateByUrl(this.redirectUrl);
    // }
  }

  returnToPlans() {
    window.location.href = this.shopWindowLink;
  }
    ngOnInit() {
      if(this.classificationIdentifier && this.classificationIdentifier === 'plano-mensal'){
        
        if(environment.one_environment === 'dev' || environment.one_environment === 'hom'){
          this.newChangeLink = "https://monitoring-frontend-periscope-serasa-empreendedor-stg.apps.internal.appcanvas.net/v2/assinatura";
        }else { //PRD
          this.newChangeLink = "https://www.serasaempreendedor.com.br/v2/assinatura";
        }
      }else{
        this.newChangeLink = "../" + this.changeLink;
      }
    }
}
